var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { apiGetListRfpNegotiate } from '@/actions/ProfessionalRfpNegotiateActionsTs';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { RfpProfessionalNegotiateSkeleton } from '@/components/modules/pages/rfp/professional/Content/RfpProfessionalNegotiateContent/RfpProfessionalNegotiateSkeleton';
import { RfpProfessionalOneSkeletonLayout } from '@/components/modules/pages/rfp/professional/Layout/RfpProfessionalOneSkeletonLayout';
import { useRfpOneProfessional } from '@/hooks/pages/rfp/professional/useRfpOneProfessional';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { RfpProfessionalNegotiatePage } from '@/pages/rfp/professional/RfpProfessionalNegotiate/RfpProfessionalNegotiatePage';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED } from '@/utils/constants/rfp/professional/dataType';
import { VIEW_REQUEST_PROPOSAL_TODO } from '@/utils/constants/viewRequest/proposal';
import { getIsNegotiateDisabled } from '@/utils/modules/rfp/professional/isNegotiateDisabled';
import { myPagePath, professionalRfpOnePath } from '@/utils/router/links';
export const RfpProfessionalNegotiate = (props) => {
    var _a;
    const { match, profile } = props;
    const rfpId = ((_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.id) || '';
    /** 案件詳細ページへのパス */
    const rfpOnePath = professionalRfpOnePath(rfpId);
    /** 条件相談データ */
    const negotiate = useTypeSelector((state) => { var _a; return ((_a = state.professionalRfpNegotiate) === null || _a === void 0 ? void 0 : _a.one[rfpId]) || null; });
    /**
     * 条件相談データを取得する
     */
    const fetchNegotiate = useCallback((dispatch, { id }) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapDispatch(dispatch, apiGetListRfpNegotiate({ path: { id } }, { id }));
    }), []);
    // 案件詳細取得, ページ状態管理
    const { loading, rfp } = useRfpOneProfessional({
        afterCallbackInApproved: fetchNegotiate,
    });
    // ローディング表示
    if (loading && !rfp) {
        return (_jsx(RfpProfessionalOneSkeletonLayout, { skeletonComponent: _jsx(RfpProfessionalNegotiateSkeleton, {}) }));
    }
    // リダイレクト：案件が取得できなかった
    if (!loading && !rfp) {
        return _jsx(CustomRedirect, { to: myPagePath() });
    }
    // リダイレクト：閲覧申請未承認だった
    if (rfp.data_type === RFP_PROFESSIONAL_DATA_TYPE_UNAPPROVED.value) {
        return _jsx(CustomRedirect, { to: rfpOnePath });
    }
    /** 条件相談リンクが無効化されているか */
    const isNegotiateDisabled = getIsNegotiateDisabled(rfp.proposal === VIEW_REQUEST_PROPOSAL_TODO.value);
    // リダイレクト：条件相談できない状態 or 条件相談が取得できなかった
    if (isNegotiateDisabled || (!loading && !negotiate)) {
        return _jsx(CustomRedirect, { to: rfpOnePath });
    }
    return (_jsx(RfpProfessionalNegotiatePage, { negotiate: negotiate, profile: profile, rfp: rfp }));
};
